import { render } from "./StepInfo.vue?vue&type=template&id=40c39c07&scoped=true"
import script from "./StepInfo.vue?vue&type=script&lang=js"
export * from "./StepInfo.vue?vue&type=script&lang=js"

import "./StepInfo.vue?vue&type=style&index=0&id=40c39c07&lang=css"
import "./StepInfo.vue?vue&type=style&index=1&id=40c39c07&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c39c07"]])

export default __exports__